module.exports = __webpack_public_path__ + "img/duplicate-button.217c2457.svg";